import { LegalPage } from "../components/site/LegalPage";

const S = [
  ["1. आम्ही फक्त प्लॅटफॉर्म आहोत · Platform only", <>
    <p>99Bazaar हा फक्त जाहिरात प्लॅटफॉर्म आहे. खरेदीदार आणि विक्रेता थेट व्यवहार करतात. व्यवहाराची, वस्तूच्या गुणवत्तेची, पैशांची किंवा डिलिव्हरीची जबाबदारी आमची नाही.</p>
    <p>99Bazaar Maharashtra is only an advertising platform. We are not a party to any deal and are not responsible for any transaction, product, payment or loss.</p>
  </>],
  ["2. नो ब्रोकर नियम · No broker policy", <p>दलाल, एजंट किंवा कमिशन घेणाऱ्यांनी जाहिराती टाकू नयेत. अशा जाहिराती आणि खाती सूचना न देता हटवली जाऊ शकतात.</p>],
  ["3. Membership", <>
    <p>एक प्लॅन: ₹99 मध्ये 1 वर्ष (365 दिवस) - Unlimited जाहिराती आणि सर्व संपर्क. नवीन नोंदणीवर 3 दिवस Free Trial.</p>
    <p>प्लॅन संपल्यावर तुमच्या जाहिराती आपोआप लपवल्या जातात, संपर्क दिसत नाही आणि नवीन जाहिरात टाकता येत नाही. Renew केल्यावर सर्व पुन्हा सुरू होते.</p>
    <p>Membership फी प्लॅटफॉर्म वापरासाठी आहे आणि भरल्यानंतर परत (refund) मिळत नाही, जोपर्यंत तांत्रिक चूक आमच्याकडून झाली नसेल.</p>
  </>],
  ["4. जाहिरातींचे नियम · Ad rules", <ul className="list-disc pl-5 space-y-1">
    <li>फक्त महाराष्ट्रातील, कायदेशीर वस्तू/सेवा.</li>
    <li>खोटी माहिती, चोरीची वस्तू, शस्त्रे, अमली पदार्थ, प्राणी तस्करी, प्रौढ सामग्री - सक्त मनाई.</li>
    <li>फोटो व माहिती तुमची स्वतःची असावी.</li>
    <li>Spam किंवा नियमभंग करणाऱ्या जाहिराती Admin कधीही हटवू शकतो.</li>
  </ul>],
  ["5. सुरक्षितता · Safety", <p>वस्तू प्रत्यक्ष पाहूनच पैसे द्या. Advance देऊ नका. OTP/PIN कोणालाही सांगू नका. सार्वजनिक ठिकाणी भेटा. गाडी/प्रॉपर्टीची कागदपत्रे तपासा.</p>],
  ["6. कायदा · Governing law", <p>या अटी भारतीय कायद्यानुसार आहेत. कोणताही वाद पुणे, महाराष्ट्र येथील न्यायालयाच्या कक्षेत येईल.</p>],
];

export default function Terms() {
  return <LegalPage title="Terms & Conditions · नियम व अटी" updated="June 2026" sections={S} testId="terms-page" />;
}
